import { API } from 'aws-amplify';

let lastCall = null

export async function getReporteVentas(contribuyente, from, to, paginacion, filtros){
	
	try{
		if( lastCall != null )
			API.cancel(lastCall, "Se ha vuelto a llamar");
	
		let params = {
			queryStringParameters: { contribuyente, from, to, ...paginacion, ...filtros },
			headers: {}
		};
	
		lastCall = API.get('apiBoletaSII', '/consultar-reportes', params);
	
		let resp = await lastCall;

		lastCall = null;
		return resp;
	}catch(err){
		if( !API.isCancel(err) ){
			
			lastCall = null;
		}

		throw err;
	}
}